import { Component, Input } from '@angular/core';
import { ApplicationStatusCode } from '../../models/application-general.model';
import { StatusTone } from 'src/app/shared/components/status-chip/status-chip.component';

@Component({
  standalone: false,
  selector: 'app-application-status-badge',
  templateUrl: './application-status-badge.component.html',
  styleUrls: ['./application-status-badge.component.scss']
})
export class ApplicationStatusBadgeComponent {
  @Input() applicationStatusCode?: ApplicationStatusCode;
  @Input() isGlobalStatus?: boolean;

  get tone(): StatusTone {
    switch (this.applicationStatusCode) {
      case ApplicationStatusCode.approved:
        return 'success';
      case ApplicationStatusCode.rejected:
      case ApplicationStatusCode.error:
        return 'error';
      case ApplicationStatusCode.archived:
      case ApplicationStatusCode.canceled:
        return 'neutral';
      case ApplicationStatusCode.pendingManagerApproval:
      case ApplicationStatusCode.screening:
      case ApplicationStatusCode.pendingScreeningManualApproval:
        return 'warning';
      default:
        return 'info';
    }
  }

  get label(): string {
    switch (this.applicationStatusCode) {
      case ApplicationStatusCode.new:                            return 'New';
      case ApplicationStatusCode.inProgress:                    return 'In Progress';
      case ApplicationStatusCode.completed:                     return 'Completed';
      case ApplicationStatusCode.pendingPaymentPlanApproval:    return 'Pending Payment Plan';
      case ApplicationStatusCode.approved:                      return 'Approved';
      case ApplicationStatusCode.rejected:                      return 'Declined';
      case ApplicationStatusCode.canceled:                      return 'Canceled';
      case ApplicationStatusCode.error:                         return 'Error';
      case ApplicationStatusCode.pendingManagerApproval:        return 'Pending Approval';
      case ApplicationStatusCode.archived:                      return 'Closed';
      case ApplicationStatusCode.screening:                     return 'Screening';
      case ApplicationStatusCode.pendingScreeningManualApproval: return 'Pending Screening';
      case ApplicationStatusCode.reopened:                      return 'Reopened';
      default:                                                  return 'Unknown';
    }
  }
}
